import JobSection from "./JobSection";

const JobDetail = ({ job, company }) => {
  if (!job) {
    return null;
  }

  return (
    <div className="job-detail">
      {/* JOB HEADER */}
      <div className="job-detail-header">
        <div className="job-detail-label">CAREER OPPORTUNITY</div>

        <h1 className="job-detail-title">{job.title}</h1>
      </div>

      {/* JOB SECTIONS */}
      <div className="job-detail-sections">
        {job.sections?.map((section, index) => (
          <JobSection key={`${section.title}-${index}`} section={section} />
        ))}
      </div>

      {/* BENEFITS */}
      <section className="job-common-section">
        <h4 className="job-section-title">BENEFITS</h4>

        <ul className="job-bullet-list">
          {company?.benefits?.map((benefit, index) => (
            <li key={`${benefit}-${index}`}>
              <span className="job-bullet-text">{benefit}</span>
            </li>
          ))}
        </ul>
      </section>

      {/* WORKPLACE */}
      <section className="job-common-section">
        <h4 className="job-section-title">WORKPLACE</h4>

        <p className="job-company-value">{company?.workplace}</p>
      </section>

      {/* CONTACT */}
      <section className="job-common-section">
        <h4 className="job-section-title">CONTACT</h4>

        <a href={`mailto:${company?.email}`} className="job-email">
          {company?.email}
        </a>
      </section>
    </div>
  );
};

export default JobDetail;
